import React, { useState } from "react";
import { Row, Col, Input, Button, ButtonGroup } from "reactstrap";
import { constants as CONST } from "../../../constants/buttonconstant";
import moment from "moment";
import Calendar from "components/Calendar/Calendar";
import JobListTable from "./JobListTable";
import JobsCount from "./JobsCount";
import { useHistory } from "react-router-dom";
import { constants as ROUTE_CONST } from "constants/routes";

const DashboardJobs = () => {
  const [nav, setNav] = useState(0);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [month, setMonth] = useState({
    startDate: moment(new Date()).startOf("month").format("YYYY-MM-DD"),
    endDate: moment(new Date()).endOf("month").format("YYYY-MM-DD"),
  });
  const [selectedOption, setSelectedOption] = useState({});
  const [calender, setCalender] = useState(false);
  const toggle = () => setCalender(true);
  const toggle1 = () => setCalender(false);
  const onChangeSelection = (e) => {
    if (e.target.value === "") {
      setSelectedOption({});
    } else {
      setSelectedOption({ status: e.target.value });
    }
  };

  const history = useHistory();
  const onNewJobPost = () => {
    history.push(`${ROUTE_CONST.JOBS}${ROUTE_CONST.CREATE_JOB}`);
  };

  const currentDate = new Date();

  const previousMonth = () => {
    var CurrMonth = moment(currentMonth)
      .subtract(1, "months")
      .format("MMMM YYYY");
    setCurrentMonth(CurrMonth);
    setMonth({
      startDate: moment(month.startDate)
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      endDate: moment(month.endDate).subtract(1, "months").format("YYYY-MM-DD"),
    });
  };

  const nextMonth = () => {
    var CurrMonth = moment(currentMonth).add(1, "months").format("MMMM YYYY");
    setCurrentMonth(CurrMonth);
    setMonth({
      startDate: moment(month.startDate).add(1, "months").format("YYYY-MM-DD"),
      endDate: moment(month.endDate).add(1, "months").format("YYYY-MM-DD"),
    });
  };
  // const decreaseMonth = (e) => {
  //   setNav(nav - 1)
  // }
  // const increaseMonth = (e) => {
  //   setNav(nav + 1)
  // }

  // useEffect(() => {
  //   console.log('navnav', nav);
  // }, [nav])

  return (
    <div>
      <div className="content">
        <Row>
          <div className="page-title">
            <div className="float-left">
              <h1 className="title ml-3">Jobs</h1>
            </div>
          </div>
          <Col xs={12} md={12}>
            <div className="row">
              <JobsCount month={month} status="NEW" title="New Job" />
              <JobsCount month={month} status="TAKEN" title="Taken" />
              <JobsCount month={month} status="COMPLETED" title="Completed" />
            </div>
          </Col>
        </Row>
        <div>
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.05588 19.3515C2.68551 19.3515 2.36144 19.2126 2.08366 18.9349C1.80588 18.6571 1.66699 18.333 1.66699 17.9626V3.61079C1.66699 3.24042 1.80588 2.91634 2.08366 2.63856C2.36144 2.36079 2.68551 2.2219 3.05588 2.2219H4.56051V1.5506C4.56051 1.34998 4.62996 1.18023 4.76884 1.04134C4.90773 0.902452 5.0852 0.833008 5.30125 0.833008C5.5173 0.833008 5.69863 0.902452 5.84523 1.04134C5.99184 1.18023 6.06514 1.3577 6.06514 1.57375V2.2219H13.9355V1.5506C13.9355 1.34998 14.005 1.18023 14.1438 1.04134C14.2827 0.902452 14.4602 0.833008 14.6763 0.833008C14.8923 0.833008 15.0736 0.902452 15.2202 1.04134C15.3668 1.18023 15.4401 1.3577 15.4401 1.57375V2.2219H16.9448C17.3151 2.2219 17.6392 2.36079 17.917 2.63856C18.1948 2.91634 18.3337 3.24042 18.3337 3.61079V17.9626C18.3337 18.333 18.1948 18.6571 17.917 18.9349C17.6392 19.2126 17.3151 19.3515 16.9448 19.3515H3.05588ZM3.05588 17.9626H16.9448V8.00893H3.05588V17.9626ZM3.05588 6.62004H16.9448V3.61079H3.05588V6.62004ZM3.05588 6.62004V3.61079V6.62004Z"
                  fill="#414248"
                />
              </svg>
              {!calender && (
                <>
                  <h3
                    style={{
                      fontFamily: "Barlow",
                      margin: "0 8px 0 10px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      fontSize: "20px",
                      color: "#414248",
                      width: "145px",
                    }}
                  >
                    {moment(month.startDate).format("MMMM YYYY")}
                  </h3>

                  <ButtonGroup className="mr-4">
                    <Button
                      onClick={() => previousMonth()}
                      color="primary"
                      type="button"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <svg
                        width="8"
                        height="14"
                        viewBox="0 0 8 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.57963 13.799L0.164491 7.38381C0.103568 7.32289 0.0609225 7.26197 0.0365535 7.20104C0.0121845 7.14012 0 7.07311 0 7C0 6.92689 0.0121845 6.85988 0.0365535 6.79896C0.0609225 6.73803 0.103568 6.67711 0.164491 6.61619L6.57963 0.201044C6.71366 0.0670149 6.88425 0 7.09138 0C7.29852 0 7.4691 0.0670149 7.60313 0.201044C7.74935 0.347259 7.82245 0.520888 7.82245 0.721932C7.82245 0.922976 7.74935 1.09661 7.60313 1.24282L1.84595 7L7.60313 12.7572C7.74935 12.9034 7.81941 13.077 7.81331 13.2781C7.80722 13.4791 7.73716 13.6466 7.60313 13.7807C7.45692 13.9269 7.28329 14 7.08224 14C6.8812 14 6.71366 13.933 6.57963 13.799Z"
                          fill="#4E79EE"
                        />
                      </svg>
                    </Button>
                    <Button
                      color="primary"
                      onClick={() => nextMonth()}
                      type="button"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                      }}
                    >
                      <svg
                        width="8"
                        height="14"
                        viewBox="0 0 8 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.210405 13.7808C0.0764667 13.6347 0.00645341 13.4642 0.000365288 13.2694C-0.00572283 13.0746 0.0642905 12.9041 0.210405 12.758L5.96368 7.00475L0.210405 1.25147C0.0764667 1.11754 0.00645341 0.950112 0.000365288 0.749204C-0.00572283 0.548296 0.0642905 0.374785 0.210405 0.22867C0.344344 0.0825549 0.511767 0.00645341 0.712675 0.000365287C0.913583 -0.00572283 1.08709 0.0642907 1.23321 0.210406L7.644 6.6212C7.70488 6.68208 7.7475 6.74296 7.77185 6.80384C7.7962 6.86472 7.80838 6.93169 7.80838 7.00475C7.80838 7.07781 7.7962 7.14478 7.77185 7.20566C7.7475 7.26654 7.70488 7.32742 7.644 7.3883L1.23321 13.7991C1.09927 13.933 0.931848 14 0.73094 14C0.530032 14 0.35652 13.9269 0.210405 13.7808Z"
                          fill="#4E79EE"
                        />
                      </svg>
                    </Button>
                  </ButtonGroup>
                </>
              )}
            </div>
            <div className="rounded float-right d-flex">
              {!calender && (
                <Input
                  type="select"
                  name="select"
                  className="mr-4"
                  onChange={onChangeSelection}
                  value={selectedOption.status}
                  style={{ width: "auto" }}
                >
                  <option value={""}>Select Status</option>
                  <option value={CONST.NEW_JOB}>New Job</option>
                  <option value={CONST.TAKEN}>Taken</option>
                  <option value={CONST.PENDING_VERIFICATION}>Pending</option>
                  <option value={CONST.PENDING_DISPUTE_RESOLUTION}>
                    Dispute
                  </option>
                  <option value={CONST.EXPIRED}>Expired</option>
                  <option value={CONST.CANCELED}>Canceled</option>
                  <option value={CONST.COMPLETED}>Completed</option>
                </Input>
              )}
              <ButtonGroup className="mr-4">
                <Button
                  color="primary"
                  onClick={toggle1}
                  active={!calender}
                  type="button"
                  style={{ borderRadius: "4px 0px 0px 4px" }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.41667 13.7222C3.02778 13.7222 2.69444 13.588 2.41667 13.3194C2.13889 13.0509 2 12.7222 2 12.3333C2 11.9444 2.13889 11.6157 2.41667 11.3472C2.69444 11.0787 3.02778 10.9444 3.41667 10.9444C3.78704 10.9444 4.10648 11.0833 4.375 11.3611C4.64352 11.6389 4.77778 11.963 4.77778 12.3333C4.77778 12.7037 4.64352 13.0278 4.375 13.3056C4.10648 13.5833 3.78704 13.7222 3.41667 13.7222ZM3.38889 6.77778C3 6.77778 2.6713 6.64352 2.40278 6.375C2.13426 6.10648 2 5.77778 2 5.38889C2 5 2.13426 4.6713 2.40278 4.40278C2.6713 4.13426 3 4 3.38889 4C3.77778 4 4.10648 4.13426 4.375 4.40278C4.64352 4.6713 4.77778 5 4.77778 5.38889C4.77778 5.77778 4.64352 6.10648 4.375 6.375C4.10648 6.64352 3.77778 6.77778 3.38889 6.77778ZM3.41667 20.6667C3.02778 20.6667 2.69444 20.5324 2.41667 20.2639C2.13889 19.9954 2 19.6759 2 19.3056C2 18.9167 2.13889 18.5833 2.41667 18.3056C2.69444 18.0278 3.02778 17.8889 3.41667 17.8889C3.78704 17.8889 4.10648 18.0278 4.375 18.3056C4.64352 18.5833 4.77778 18.9167 4.77778 19.3056C4.77778 19.6759 4.64352 19.9954 4.375 20.2639C4.10648 20.5324 3.78704 20.6667 3.41667 20.6667ZM8.38889 20.1111C8.14815 20.1111 7.94907 20.0324 7.79167 19.875C7.63426 19.7176 7.55556 19.5185 7.55556 19.2778C7.55556 19.037 7.63426 18.838 7.79167 18.6806C7.94907 18.5231 8.14815 18.4444 8.38889 18.4444H21.1667C21.4074 18.4444 21.6065 18.5231 21.7639 18.6806C21.9213 18.838 22 19.037 22 19.2778C22 19.5185 21.9213 19.7176 21.7639 19.875C21.6065 20.0324 21.4074 20.1111 21.1667 20.1111H8.38889ZM8.38889 13.1667C8.14815 13.1667 7.94907 13.088 7.79167 12.9306C7.63426 12.7731 7.55556 12.5741 7.55556 12.3333C7.55556 12.0926 7.63426 11.8935 7.79167 11.7361C7.94907 11.5787 8.14815 11.5 8.38889 11.5H21.1667C21.4074 11.5 21.6065 11.5787 21.7639 11.7361C21.9213 11.8935 22 12.0926 22 12.3333C22 12.5741 21.9213 12.7731 21.7639 12.9306C21.6065 13.088 21.4074 13.1667 21.1667 13.1667H8.38889ZM8.38889 6.22222C8.14815 6.22222 7.94907 6.14352 7.79167 5.98611C7.63426 5.8287 7.55556 5.62963 7.55556 5.38889C7.55556 5.14815 7.63426 4.94907 7.79167 4.79167C7.94907 4.63426 8.14815 4.55556 8.38889 4.55556H21.1667C21.4074 4.55556 21.6065 4.63426 21.7639 4.79167C21.9213 4.94907 22 5.14815 22 5.38889C22 5.62963 21.9213 5.8287 21.7639 5.98611C21.6065 6.14352 21.4074 6.22222 21.1667 6.22222H8.38889Z"
                      fill="white"
                    />
                  </svg>
                </Button>
                <Button
                  color="primary"
                  onClick={toggle}
                  active={calender}
                  type="button"
                  style={{ borderRadius: "0px 4px 4px 0px" }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.05588 19.3515C2.68551 19.3515 2.36144 19.2126 2.08366 18.9349C1.80588 18.6571 1.66699 18.333 1.66699 17.9626V3.61079C1.66699 3.24042 1.80588 2.91634 2.08366 2.63856C2.36144 2.36079 2.68551 2.2219 3.05588 2.2219H4.56051V1.5506C4.56051 1.34998 4.62996 1.18023 4.76884 1.04134C4.90773 0.902452 5.0852 0.833008 5.30125 0.833008C5.5173 0.833008 5.69863 0.902452 5.84523 1.04134C5.99184 1.18023 6.06514 1.3577 6.06514 1.57375V2.2219H13.9355V1.5506C13.9355 1.34998 14.005 1.18023 14.1438 1.04134C14.2827 0.902452 14.4602 0.833008 14.6763 0.833008C14.8923 0.833008 15.0736 0.902452 15.2202 1.04134C15.3668 1.18023 15.4401 1.3577 15.4401 1.57375V2.2219H16.9448C17.3151 2.2219 17.6392 2.36079 17.917 2.63856C18.1948 2.91634 18.3337 3.24042 18.3337 3.61079V17.9626C18.3337 18.333 18.1948 18.6571 17.917 18.9349C17.6392 19.2126 17.3151 19.3515 16.9448 19.3515H3.05588ZM3.05588 17.9626H16.9448V8.00893H3.05588V17.9626ZM3.05588 6.62004H16.9448V3.61079H3.05588V6.62004ZM3.05588 6.62004V3.61079V6.62004Z"
                      fill="white"
                    />
                  </svg>
                </Button>
              </ButtonGroup>
              <Button
                active={true}
                color="primary"
                type="button"
                className="m-0"
                style={{ borderRadius: "4px" }}
                onClick={onNewJobPost}
              >
                Create New Job
              </Button>
            </div>
          </div>
          {!calender && (
            // <JobListTable month={month} filterStatus={selectedOption} />
            <JobListTable month={month} filterStatus={selectedOption} />
          )}
          {calender && (
            <Calendar currentDate={currentDate} nav={nav} setNav={setNav} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardJobs;
